import { render, staticRenderFns } from "./NewLogin.vue?vue&type=template&id=40dbd7f7"
import script from "./NewLogin.vue?vue&type=script&lang=js"
export * from "./NewLogin.vue?vue&type=script&lang=js"
import style0 from "./NewLogin.vue?vue&type=style&index=0&id=40dbd7f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports